/* @ngInject */
function AuditSocialMediaController ($scope, $rootScope, $location, $stateParams, $translate, Utils, ToastService, SocialMediaService, SegmentService, OnboardingDialogService, UiElementViewLogService) {
  $scope.flags = {
    loading: false
  }

  $scope.activityFilters = {}

  $scope.activityFiltersList = ['date', 'accounts', 'groups', 'contentType', 'nonConformity']

  $scope.accountsFilters = {}

  $scope.accountsFiltersList = ['accounts', 'groups']

  $scope.posts = []

  $scope.lastUpdate = ''

  const api = {
    _isCorrectTab,
    _getLastUpdate,
    _onTrackPageViewEvent,
    _openOnboardingDialog
  }
  this.getApi = () => api

  activate()

  function activate () {
    $scope.selectedTab = 'audit'

    const selectedTab = $stateParams.selectedTab
    const isCorrectTab = api._isCorrectTab(selectedTab)

    if (selectedTab && isCorrectTab) {
      $scope.selectedTab = selectedTab.toLowerCase()
    }

    api._getLastUpdate()
    api._onTrackPageViewEvent()
    api._openOnboardingDialog()
  }

  $scope.getLastUpdateDate = () => {
    const lastUpdate = $scope.lastUpdate

    if (!lastUpdate) return ''

    const currentDate = new Date(lastUpdate)
    const locale = $rootScope.oUser.locale

    const lastUpdateText = $translate.instant('socialMedia.lastUpdatedIn')

    const datePart = Utils.formatDate(currentDate, locale, {
      day: '2-digit',
      month: '2-digit'
    })

    const timePart = Utils.formatDate(currentDate, locale, {
      hour: '2-digit',
      minute: '2-digit'
    })

    return `${lastUpdateText} ${datePart} - ${timePart}`
  }

  $scope.onTabChange = (event) => {
    const selectedTab = event.detail.selected

    if (selectedTab && selectedTab !== $scope.selectedTab) {
      $scope.selectedTab = selectedTab
      $location.search({ selectedTab })
    }
  }

  function _isCorrectTab (tab = '') {
    const lowerCaseTab = tab ? tab.toLowerCase() : ''
    const acceptedTabs = ['audit', 'accounts']
    return acceptedTabs.includes(lowerCaseTab)
  }

  async function _getLastUpdate () {
    const socialType = 'instagram'

    try {
      const response = await SocialMediaService.lastUpdate(socialType)
      $scope.lastUpdate = response.lastUpdate
    } catch (err) {
      console.log({ err })
      ToastService.defaultErrorToast()
      $scope.lastUpdate = ''
    }
  }

  function _onTrackPageViewEvent () {
    SegmentService.track('social-media-audit-pageview')
  }

  function _openOnboardingDialog () {
    UiElementViewLogService.getElementViewLog('checklist-social-media-onboarding-dialog').then((elementViewLog) => {
      if (elementViewLog || $rootScope.isWorkflowPlan()) return

      const data = {
        title: $translate.instant('onboardingDialogChecklist.title'),
        description: OnboardingDialogService.getChecklistDescription(),
        slides: [
          { image: '/assets/img/onboarding/onboarding_checklist.png' }
        ],
        primaryButton: {
          text: $translate.instant('getStarted'),
          onClick: () => {
            UiElementViewLogService.createElementViewLog('checklist-social-media-onboarding-dialog')
          }
        }
      }

      OnboardingDialogService.openDialog(data)
    })
  }
}

export { AuditSocialMediaController }
